<template>
     <router-view >
  </router-view>
</template>

<script>
export default {
  name: 'App',
  components: {
 
  },
  
  data(){
    return {
   
    }
  },  
  setup(){
   
  },
  created() {
   
  },
  mounted() {
    
  },
  methods:{
   
  }
}
</script>

<style lang="scss">

</style>
